import PropTypes from 'prop-types';
import React from 'react';
import { connectToStores } from 'fluxible-addons-react';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import { StickyContainer, Sticky } from 'react-sticky';
import DocumentStore from '../../stores/DocumentStore';
import NavigationStore from '../../stores/NavigationStore';
import Spinner from '../Spinner';

class ApiExplorer extends React.Component {
  componentDidMount() {
    window.initApiExplorer(this.props.languages);
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { doc } = nextProps;
    if (!doc || !doc.html || !doc.meta) {
      return false;
    }
    return PureRenderMixin.shouldComponentUpdate(this, nextProps, nextState);
  }

  renderContent() {
    const { doc } = this.props;

    // If the document hasn't been loaded yet, display a spinner.
    if (!doc || !doc.html || !doc.meta) {
      return <Spinner />;
    }

    return <div dangerouslySetInnerHTML={{ __html: doc.html }} />;
  }

  render() {
    const { title, languages } = this.props;

    return (
      <StickyContainer>
        <section
          className="content api-explorer"
          data-swiftype-name="body"
          data-swiftype-type="text"
          data-swiftype-index="true"
        >
          <div className="api-sidebar tocify-wrapper">
            <div className="sticky-nav-placeholder">
              <Sticky>
                {({ style }) => (
                  <div style={style}>
                    <div className="sticky-nav">
                      <div className="sticky-nav-selected">
                        <span>Menu</span>
                        <i className="icon-budicon-460" />
                      </div>
                      <div id="toc">
                        <div className="title">{title}</div>
                      </div>
                    </div>
                  </div>
                )}
              </Sticky>
            </div>
          </div>
          <div className="page-wrapper">
            <div className="dark-box" />
            <div className="lang-selector-container">
              <Sticky>
                {({ isSticky, style }) => (
                  <div style={style} className={isSticky ? 'sticky lang-mobile-sticky' : ''}>
                    <div className="lang-selector">
                      <div className="lang-selector-selected">
                        <span className="language-label">Language:</span>
                        <span className="language js-selected-language" />
                        <i className="icon-budicon-460" />
                      </div>
                      {languages.map(language => (
                        <a
                          href={`#${language.key}`}
                          key={language.key}
                          data-language-name={language.key}
                        >
                          {language.name}
                        </a>
                      ))}
                    </div>
                  </div>
                )}
              </Sticky>
            </div>
            <div className="api-content">
              {this.renderContent()}
            </div>
          </div>
        </section>
      </StickyContainer>
    );
  }
}

ApiExplorer.propTypes = {
  doc: PropTypes.object,
  currentRoute: PropTypes.object,
  languages: PropTypes.array,
  title: PropTypes.string
};

export default connectToStores(ApiExplorer, [DocumentStore, NavigationStore], (context, props) => {
  const { url } = props.currentRoute;
  const doc = context.getStore(DocumentStore).getDocument(url);
  return { doc };
});
